import { Row, Col, Table, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import Back from "../../../assets/images/backIcon.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";

const ProductDetailPanel = ({
  stockList,
  setStockList,
  selectedProductInCart,
  currenciesList,
  pricePrecision,
  modifyProductList,
  handleViewStockClick,
}) => {
  if (stockList.length > 0) {
    return (
      <div>
        <img
          src={Back}
          onClick={() => setStockList([])}
          id="sm-parked-bill-back"
          style={{
            height: "2vw",
            paddingBottom: "0.5em",
            cursor: "pointer",
            marginLeft: "10px",
            marginTop: "0.7em",
          }}
        />
        <Table
          style={{
            width: "100%",
            overflowY: "auto",
            borderRadius: "10px",
            padding: "0",
            height: "36vh",
            background: "#fff",
            maxHeight: "34vh",
            display: "block",
          }}
          size="small"
          locale={{ emptyText: "No data" }}
          pagination={false}
          dataSource={[...stockList]}
          className="sm-stock-table"
          columns={[
            {
              title: "Store",
              dataIndex: "store",
              key: "store",
              render: (text, record) => <div>{record?.warehouse?.name || ""}</div>,
            },
            {
              title: "In Stock",
              dataIndex: "stock",
              key: "stock",
              render: (text, record) => <div>{record?.warehouse?.storageBin?.totalQty || 0}</div>,
              align: "right",
            },
          ]}
        />
      </div>
    );
  }

  if (selectedProductInCart?.productSegment === "CB" && selectedProductInCart?.childItems?.length > 0) {
    return (
      <div style={{ position: "relative", padding: "0.5rem", borderRadius: "6px", backgroundColor: "#fff", height: "100%" }}>
        <Row
          style={{ padding: "0.1rem 0.75rem", fontSize: "0.75rem", fontWeight: 600, color: "#2F3856", borderBottom: "1px solid #e8e8e8", marginBottom: "0.5rem" }}
        >
          <Col span={8}>Name</Col>
          <Col span={6} style={{ textAlign: "right" }}>Unit Price</Col>
          <Col span={4} style={{ textAlign: "right" }}>Qty</Col>
          <Col span={6} style={{ textAlign: "right" }}>Total Price</Col>
        </Row>

        <Scrollbars style={{ height: "28vh" }}>
          {selectedProductInCart.childItems.map((item) => {
            const unitPrice = parseFloat(item.sunitprice) || 0;
            const quantity = parseFloat(item.weight * selectedProductInCart.weight) || 0;
            const totalPrice = unitPrice * quantity;

            return (
              <Row
                key={item.id || item.name}
                style={{
                  padding: "0 0.75rem",
                  width: "100%",
                  marginBottom: "0.4rem",
                  height: "auto",
                  alignItems: "center",
                }}
              >
                <Col span={8}>
                  <p
                    title={item.name}
                    style={{
                      margin: 0, fontSize: "0.65rem", fontWeight: 500, color: "#333",
                      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%",
                    }}
                  >
                    {item.name}
                  </p>
                </Col>
                <Col span={6} style={{ textAlign: "right" }}>
                  <p style={{ margin: 0, fontSize: "0.6rem", color: "#2F3856" }}>{unitPrice.toLocaleString("en-IN")}</p>
                </Col>
                <Col span={4} style={{ textAlign: "right" }}>
                  <p style={{ margin: 0, fontSize: "0.6rem", color: "#2F3856" }}>{quantity}</p>
                </Col>
                <Col span={6} style={{ textAlign: "right" }}>
                  <p style={{ margin: 0, fontSize: "0.6rem", color: "#2F3856" }}>{totalPrice.toLocaleString("en-IN")}</p>
                </Col>
              </Row>
            );
          })}
        </Scrollbars>

        <Button
          style={{
            position: "absolute", bottom: "0.5rem", right: "0.5rem",
            backgroundColor: "#2F3856", color: "#fff", width: "7vw", height: "4.5vh",
            borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center",
            border: "none", fontSize: "0.75rem",
          }}
          onClick={modifyProductList}
        >
          Modify
        </Button>
      </div>
    );
  }

  return (
    <Row gutter={[16]} style={{ paddingTop: "3vh" }}>
      <Col span={7} style={{ height: "24vh" }}>
        <img
          style={{
            width: "100%", height: "27vh", objectFit: "contain", borderRadius: "5px",
            paddingTop: "1vh", alignSelf: "center", padding: "1vh 0 1vh 0.8vw",
          }}
          src={selectedProductInCart.imageurl || DefaultProductImage}
          alt=""
        />
      </Col>
      <Col span={17} style={{ height: "24vh", position: "relative" }}>
        <p style={{ margin: 0, fontWeight: "500", color: "#0F0718", fontSize: "0.82rem", fontFamily: "Inter" }}>
          {selectedProductInCart["name"]?.toString().substring(0, 27)}...
        </p>
        <p style={{ margin: 0, fontWeight: "500", color: "#0F0718", fontSize: "0.82rem", fontFamily: "Inter" }}>
          {selectedProductInCart["productBrandName"]}
        </p>
        <p style={{ margin: 0, fontWeight: "500", color: "#0F0718", fontSize: "2em", fontFamily: "Inter" }}>
          {currenciesList[0].symbolRightSide === "N"
            ? `${currenciesList[0].currSymbol}`
            : currenciesList[0].symbolRightSide === "Y"
              ? `${currenciesList[0].currSymbol}`
              : ""}{" "}
          {Number(selectedProductInCart["realPrice"]).toFixed(pricePrecision)}
        </p>
        <p style={{ margin: 0, fontWeight: "500", color: "#0F0718", fontSize: "0.82rem", fontFamily: "Inter" }}>
          Quantity : {selectedProductInCart["weight"]}
        </p>
        {stockList.length > 0 ? (
          <CloseCircleOutlined
            onClick={() => setStockList([])}
            style={{ position: "absolute", top: "25vh", left: "18vw", cursor: "pointer" }}
          />
        ) : null}
        <button
          onClick={handleViewStockClick}
          style={{
            backgroundColor: "#046307C2", border: "1px solid #fff", borderRadius: "7px",
            height: "5vh", width: "7vw", cursor: "pointer",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", color: "#fff", fontSize: "1em", fontWeight: 500, fontFamily: "Inter" }}>
            View Stock
          </div>
        </button>
        {stockList.map((record) => (
          <p key={record.id || record.name} style={{ margin: 0, fontWeight: "500", fontSize: "1em", color: "#0F0718", fontFamily: "Inter" }}>
            {record?.name || ""} stock : {record?.warehouse?.storageBin?.totalQty || 0}
          </p>
        ))}
      </Col>
    </Row>
  );
};

export default ProductDetailPanel;
